import {
  Stack,
  Paper,
  Avatar,
  InputBase,
  Typography,
} from "@mui/material";

const MyInput = ({
  sx={},
  name,
  type,
  icon,
  error,
  value,
  title,
  endIcon,
  onChange,
  direction,
  autoFocus,
  helperText,
  placeholder,
}) => {
  return (
    <Stack>
      {title && (
        <Typography
          px={1}
          pb={0.5}
          fontSize={10}
          variant="caption"
          color="text.secondary"
        >
          {title}
        </Typography>
      )}
      <Paper
        elevation={0}
        sx={{
          borderRadius: 2,
          display: "flex",
          overflow: "hidden",
          alignItems: "stretch",
          bgcolor: "action.hover",
          border: error ? "1px dashed" : "none",
          borderColor: "error.main",
        }}
      >
        <InputBase
          fullWidth
          size="medium"
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          autoFocus={autoFocus}
          placeholder={placeholder}
          sx={{ color: "text.secondary", p: 1 }}
          inputProps={{
            style: {
              height: "100%",
              paddingLeft: 8,
              paddingRight: 8,
              direction: direction || "rtl",
              ...sx,
            },
          }}
          startAdornment={
            icon && (
              <Avatar
                variant="square"
                sx={{
                  width: 64,
                  height: 64,
                  color: "inherit",
                  bgcolor: "transparent",
                }}
              >
                {icon}
              </Avatar>
            )
          }
          endAdornment={endIcon}
        />
      </Paper>
      {helperText && (
        <Typography
          px={1}
          pt={0.5}
          fontSize={10}
          align="right"
          variant="caption"
          color="error.main"
        >
          {helperText}
        </Typography>
      )}
    </Stack>
  );
};

export default MyInput;
